import React, { Component } from "react";
import correo from '../../assets/images/correo.png';
import insta from '../../assets/images/insta.png';
import tel from '../../assets/images/tel.png';
import whats from '../../assets/images/whats.png';

import './Footer.css';
import {
    MDBRow,
    MDBCol
} from "mdbreact";

class Footer extends Component {
    render() {
        return (
            <footer className="footer">
                <div className="container">
                    <MDBCol lg="12" md="12" sm="12" xs="12" xl="12" className="lineaOrange">
                    </MDBCol>
                    <br/>
                    <h2 className="futuraBold">CONTACT CENTER UFG</h2>
                    <br/>
                    <MDBRow>
                        <MDBCol size="12" sm="12" md="6" lg="3" xl="3" className="lineaBorde itemFooter">
                            <img src={correo} className="iconoFooter" alt="Email" /> contactcenter@ufg.edu.sv
                        </MDBCol>
                        <MDBCol size="12" sm="12" md="6" lg="3" xl="3" className="lineaBorde itemFooter">
                            <img src={insta} className="iconoFooter" alt="Instagram" /> ufg.oficial
                        </MDBCol>
                        <MDBCol size="12" sm="12" md="6" lg="3" xl="3" className="lineaBorde itemFooter">
                            <img src={tel} className="iconoFooter" alt="Teléfono" /> 2209-2824
                        </MDBCol>
                        <MDBCol size="12" sm="12" md="6" lg="3" xl="3" className="itemFooter">
                            <img src={whats} className="iconoFooter" alt="Whatsapp" /> 7554-1471
                        </MDBCol>
                    </MDBRow>
                </div>
                <br/>
            </footer>
        );
    }
}
export default Footer;